import React, { useState } from 'react';
import ProfileInfoView from './ProfileInfoView';
import SubscriptionsView from './SubscriptionsView';
import ClosetView from './ClosetView';
import OutfitBoardsView from './OutfitBoardsView';
import { useCustomerData } from '../../hooks/useCustomerData';
import accountStyles from '../../styles/account.css';

export const links = () => [{ rel: 'stylesheet', href: accountStyles }];

// Container page with sidebar navigation
const Account = () => {
  const { customerData, setCustomerData } = useCustomerData();

  const Sections = {
    PROFILE: 'profile',
    SUBSCRIPTIONS: 'subscriptions',
    CLOSET: 'closet',
    OUTFIT_BOARDS: 'outfitBoards',
  };

  const [active, setActive] = useState(Sections.PROFILE);

  const renderView = () => {
    switch (active) {
      case Sections.SUBSCRIPTIONS:
        return <SubscriptionsView customerId={customerData?.id} />;
      case Sections.CLOSET:
        return <ClosetView customerData={customerData} setCustomerData={setCustomerData} />;
      case Sections.OUTFIT_BOARDS:
        return <OutfitBoardsView customerId={customerData?.id} />;
      case Sections.PROFILE:
      default:
        return <ProfileInfoView customerData={customerData} setCustomerData={setCustomerData} />;
    }
  };

  return (
    <div className="account-layout">
      <aside className="account-sidebar">
        <h3>Account</h3>
        <ul>
          <li
            className={active === Sections.PROFILE ? 'active' : ''}
            onClick={() => setActive(Sections.PROFILE)}
          >
            Profile Information
          </li>
          <li
            className={active === Sections.SUBSCRIPTIONS ? 'active' : ''}
            onClick={() => setActive(Sections.SUBSCRIPTIONS)}
          >
            Subscriptions
          </li>
          <li
            className={active === Sections.CLOSET ? 'active' : ''}
            onClick={() => setActive(Sections.CLOSET)}
          >
            Closet
          </li>
          <li
            className={active === Sections.OUTFIT_BOARDS ? 'active' : ''}
            onClick={() => setActive(Sections.OUTFIT_BOARDS)}
          >
            Outfit Boards
          </li>
        </ul>
      </aside>
      <main className="account-content">{renderView()}</main>
    </div>
  );
};

export default Account;
